import type { SeoFieldFragment, MembershipFragment, SignupFormFieldsFragment } from '~/types/craft-schema';

export const useGlobalStore = defineStore('global', {
    state: () => ({
        fetched: false,

        seo: null as SeoFieldFragment | null,

        membershipTexts: {
            cancellationText: 'Klik op de gele knop om je opzegging te bevestigen.',
            confirmText: 'Bevestigen',
            closeText: 'Annuleren',
            becomeMemberCtaLoginModal: 'Nog geen account? Word lid.',
            becomeMemberCtaLoginModalSmallText: 'Als je lid wordt van We Are Public krijg je gratis toegang tot alle progamma\'s op ons platform.',
            becomeMemberCtaDefault: 'Word lid',
            priceText: 'De eerste maand van je lidmaatschap is gratis. Daarna betaal je €20 per maand. '
                + 'Ben je jonger dan 30 jaar dan betaald je €15 per maand. '
                + 'De minimale periode van je lidmaatschap is 3 kalendermaanden (inclusief je gratis maand)',
        },

        freeAccountSignupDefinition: { } as SignupFormFieldsFragment,

        maxReservations: 5,
    }),

    actions: {
        setMembershipData(payload: MembershipFragment) {
            if (payload.richText) {
                this.membershipTexts.cancellationText = payload.richText;
            }

            if (payload.textPlain) {
                this.membershipTexts.confirmText = payload.textPlain;
            }

            if (payload.textPlain2) {
                this.membershipTexts.confirmText = payload.textPlain2;
            }

            if (payload.textPlain3) {
                this.membershipTexts.becomeMemberCtaLoginModal = payload.textPlain3;
            }
    
            if (payload.textPlain4) {
                this.membershipTexts.becomeMemberCtaDefault = payload.textPlain4;
            }

            if (payload.textPlain5) {
                this.membershipTexts.becomeMemberCtaLoginModalSmallText = payload.textPlain5;
            }
        
            if (payload.priceText) {
                this.membershipTexts.priceText = payload.priceText;
            }

            if (payload.signupForm?.[0]) {
                this.freeAccountSignupDefinition = payload.signupForm?.[0] as SignupFormFieldsFragment;
            }
        },

        setMaxReservations(payload: number) {
            this.maxReservations = payload;
        }
    }
});
